import {Exclude, Expose, instanceToPlain, plainToClass, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";
import {getDatabaseCodeTransformer} from "../transfomers/transformers";
import {FlowAllocationType, toFlowAllocationType} from "./flow-allocation-type";
import {toTransportCategory, TransportCategory} from "../transport-category";

export const PipelineValidator = t.intersection([
  t.type({
    id: t.string,
    regionId: t.string,
    companyId: t.string,
    name: t.string,
    allocationType: t.string,
    category: t.string,
  }),
  t.partial({
    freightTypeCategory: t.string,
    inactiveDttm: t.number,
    temporary: t.boolean,
    doNotUse: t.boolean,
    createDttm: t.number,
    lastModifiedDttm: t.number,
    companyName: t.string,
  }),
]);

export const PipelineArrayValidator = t.array(PipelineValidator);

export type Pipeline = t.TypeOf<typeof PipelineValidator>;
export type PipelineArray = t.TypeOf<typeof PipelineArrayValidator>;

@Exclude()
export class PipelineEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  name!: string;

  @Expose()
  regionId!: string;

  @Expose()
  companyId!: string;

  @Expose()
  companyName?: string

  @Expose()
  @Transform(getDatabaseCodeTransformer(toTransportCategory))
  category!: TransportCategory;

  @Expose()
  freightTypeCategory?: string

  @Expose()
  temporary?: boolean;

  @Expose()
  inactiveDttm?: number;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toFlowAllocationType))
  allocationType!: FlowAllocationType;

  @Expose()
  doNotUse = false

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'PIPE';

  get displayName(): Readonly<string> {
    return this.name;
  }

  /**
   * Constructor for PipelineEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(pipeline: Pipeline): PipelineEntity {
    return plainToClass(PipelineEntity, pipeline, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<Pipeline> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(PipelineValidator, object);
  }

  asTypeValue(): Pipeline {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(PipelineValidator, object);
  }
}

export interface PipelineSearchCriteria {
  ids?: string[]
  regionIds?: string[];
  companyIds?: string[]
  categories?: string[];
  freightTypeCategories?: string[]
}
